import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isNullOrEmpty, translate } from '../../utils/util';
import SelectNew from './SelectNew';
import JustificationService from '../../services/JustificationService';

const SelectJustificationUI = (props) => {
    const [justification, setJustification] = useState([]);

    useEffect(() => {
        if (!props.justifications?.items || props.justifications?.items?.length === 0) {
            props.getJustifications(props.user.vision, {});
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.justifications?.items) {
            let justificationFilter = props.justifications.items;
            if (!isNullOrEmpty(props.type)) {
                justificationFilter = props.justifications.items.filter((f) => f.justificationTypeId === parseInt(props.type));
            }
            setJustification(justificationFilter || [])
        }
        // eslint-disable-next-line
    }, [props.justifications?.items]);


    const onChange = (evt) => {
        if (props.onChange) {
            props.onChange(evt);
        }
    }

    return (
        <SelectNew
            required={props.required}
            id={props.id || 'justification'}
            name={props.id || 'justification'}
            label={translate('stock:justification')}
            placeHolder={translate('general:choose-one-option')}
            change={onChange}
            data={justification.map((i) => { return { id: i.description, text: i.description }; })}
            value={props.value}
        />
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        justifications: state.justificationReducer.justifications
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getJustifications: (vision, filter, pagination) => {
            dispatch(JustificationService.getJustifications(vision, filter, pagination));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SelectJustificationUI));
